import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class Opacity extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      opacity: this.props.chartType === "line" ?
        this.props.opacity.strokeOpacity : this.props.opacity.fillOpacity
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      opacity: nextProps.chartType === "line" ?
        nextProps.opacity.strokeOpacity : nextProps.opacity.fillOpacity
    });
  }

  componentWillMount() {
    this.opacityType = this.props.chartType === "line" ? "strokeOpacity" : "fillOpacity";
  }

  handleChange(event) {
    this.setState({
      opacity: (event.target.value / 100)
    });
    this.props.onLegendChange(this.opacityType, event.target.value / 100, true);
  }

  render() {
    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          {this.props.label === false ? null : <div className={styles.configLabel}>Opacity</div>}
          <div className={styles.configValue}>
            <input type="range"
                   min="10" max="100"
                   value={this.state.opacity * 100}
                   onChange={this.handleChange}/>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/opacity.jsx